<template>
  <div class="upload system-upload-file">
    <el-upload
      v-if="!uploading"
      :ref="'upload_'+ type"
      action="#"
      drag
      :auto-upload="false"
      :accept="acceptType"
      :limit="limitNum"
      :on-change="handleFile.bind(this,type)"
      :on-remove="handleRemove.bind(this,type)"
      :on-exceed="handleFileExceed.bind(this,type)"
      :file-list="fileList"
    >
      <div>
        <i class="el-icon-upload"/>
        <div class="el-upload__text"><em style="color:#3855F1"> Click to upload </em></div>
        <!-- <el-button size="small" type="prima
        ry">{{ $t('bdManage.click_upload_template') }}</el-button>
        <div slot="tip" class="el-upload__tip">Only excel files can be uploaded</div> -->
      </div>

    </el-upload>
    <div v-if="uploading" class="parse">
      Uploading
    </div>
    <Progress :progress="uploadingProgress"/>
  </div>

</template>
<script>
// import { uploadFileShowProgress } from '@/api/components/upload'
import {uploadFileWithProgress} from '@/api/components/upload'

export default {
  name: 'UpdateFile',
  components: {
    Progress: () => import('@/views/components/Progress.vue')
  },
  props: {
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
    limitNum: {
      type: Number,
      default: 1000
    },
    type: {
      type: [String, Number],
      default: ''
    },
    fileDir: {
      type: String,
      default: 'MERCHANT_RECHARGE'
    },
    acceptType: {
      type: String,
      default: ''
    },
    limitSize: {
      type: Number
    },
  },
  data() {
    return {
      fileList: [],
      removeFiles: [],
      uploadingProgress: 0,
      uploading: false
    }
  },
  methods: {
    // 验证文件格式（PDF、JPEG、PNG、Excel、CSV）
    // validateFileFormat(file) {
    //   const allowedTypes = [
    //     'application/pdf', // PDF
    //     'image/jpeg', // JPEG
    //     'image/png', // PNG
    //     'application/vnd.ms-excel', // Excel .xls
    //     'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Excel .xlsx
    //     'text/csv' // CSV
    //   ]
    //   const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.xls', '.xlsx', '.csv']
    //
    //   // 首先检查 MIME 类型
    //   if (file.raw && file.raw.type) {
    //     if (allowedTypes.includes(file.raw.type)) {
    //       return true
    //     }
    //   }
    //
    //   // 如果 MIME 类型不匹配或不存在，检查文件扩展名
    //   let fileName = file.name.toLowerCase()
    //   const queryIndex = fileName.indexOf('?')
    //   if (queryIndex > -1) {
    //     fileName = fileName.substring(0, queryIndex)
    //   }
    //   return allowedExtensions.some(ext => fileName.endsWith(ext))
    // },
    handleFile(type, file, fileList) {
      if (this.uploading) {
        this.$message.warning('Uploading, pls wait!')
        return
      }
      if (this.limitSize && file.size / 1024 / 1024 > this.limitSize) {
        this.$message.error(`The size of the uploaded image cannot exceed ${this.limitSize}MB!`);
        this.removeUploadFile(type, file)
        return;
      }
      console.log(file)
      if (this.acceptType && this.acceptType !== "*" && !this.acceptType.toLowerCase().includes(file.raw.name.substring(file.raw.name.lastIndexOf('.')).toLowerCase())) {
        this.$message.error(`The file type is not allowed!`);
        this.removeUploadFile(type, file)
        return;
      }
      if (/\s/g.test(file.name)) {
        this.$message.warning('The file name cannot have spaces, please modify and upload!')
        this.removeUploadFile(type, file)
        return
      }
      // 验证文件格式
      // if (this.acceptType && !this.validateFileFormat(file)) {
      //   this.$message.warning(this.$t('tips.invoice_file_format_error'))
      //   this.removeUploadFile(type, file)
      //   return
      // }
      if (this.list.length >= this.limitNum) {
        this.$message.warning(`Upload up to ${this.limitNum} files!`)
        this.removeUploadFile(type, file)
        return
      }


      const findItem = this.list.find(item => item.name === file.name)
      if (findItem) {
        this.$message.warning('The file with the same name cannot be uploaded, please upload again!')
        this.removeUploadFile(type, file)
        this.uploading = false
        this.uploadingProgress = 0
        return
      }
      this.uploading = true
      const params = {}
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('business', this.fileDir)
      params.data = formData
      // 上传进度，固定到大概95%，等后台响应成功显示100%
      params.onUploadProgress = (progressEvent) => {
        const value = Math.floor((progressEvent.loaded * 100) / (progressEvent.total * 1.05))
        this.uploadingProgress = value
      }

      uploadFileWithProgress(params).then(res => {
        if (this.removeFiles.includes(file.uid)) {
          return
        }
        const {path, ...otherData} = res.data
        this.$message.success('Uploaded Successfully')
        this.$emit('change')
        this.$emit('templateFileSuccess', {type, fileName: file.name, relativePath: path, ...otherData})
        this.fileList = []
        this.uploadingProgress = 100
        setTimeout(() => {
          this.uploadingProgress = 0
        }, 500)
      }).catch((err) => {
        // 上传失败，文件还是会显示，要移除文件
        this.removeUploadFile(type, file)
        console.error('err', err)
      }).finally(() => {
        this.uploading = false
        this.uploadingProgress = 0
      })
    },
    removeUploadFile(type = '', file) {
      const uid = file.uid
      if (!this.$refs['upload_' + type]) {
        return
      }
      const idx = this.$refs['upload_' + type].uploadFiles.findIndex(item => item.uid === uid)
      if (idx !== -1) {
        this.$refs['upload_' + type].uploadFiles.splice(idx, 1)
      }
    },
    handleRemove(type, file, fileList) {
      this.fileList = fileList
      if (file.status === 'ready') {
        this.uploadingProgress = 0
        this.uploading = false
        this.removeFiles.push(file.uid)
      }
    },
    handleFileExceed(type) {
      if (this.fileList[type].length >= this.limitNum) {
        this.$message.warning(`The current limit is ${this.limitNum}, please delete and upload again!`)
        return
      }
    }
  }
}
</script>
<style>
.system-upload-file .el-upload-dragger {
  width: 450px;
  height: 130px;
}

.system-upload-file .el-icon-upload {
  font-size: 34px;
  color: #D3D7DF;
  margin: 28px 0 16px;
  line-height: 1;
}
</style>

<style lang="scss" scoped>
.upload {
  display: inline-block;
  width: 100%;
}

.btn-update {
  margin-left: 10px;
}

.upload-container {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 100px;
  height: 100px;
  cursor: pointer;
  line-height: 100px;
  vertical-align: top;
  font-size: 12px;
  color: #8c939d;

  .icon-add {
    font-size: 8px;
  }
}

.parse {
  width: 100%;
  margin-top: 20px;
  font-size: 14px;
  color: #606266;
}
</style>
